var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 5.94238L6.55522 9.29403C6.61773 9.33012 6.68328 9.35619 6.75 9.37273V15.8731L1.16403 12.5673C0.907403 12.4154 0.75 12.1394 0.75 11.8412V5.94238ZM14.25 5.85327V11.8412C14.25 12.1394 14.0926 12.4154 13.836 12.5673L8.25 15.8731V9.31578C8.26361 9.30898 8.2771 9.30173 8.29045 9.29402L14.25 5.85327Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.932373 4.31562C1.00328 4.22607 1.09278 4.15039 1.19713 4.09482L7.10338 0.94902C7.35132 0.816961 7.64873 0.816961 7.89667 0.94902L13.8029 4.09482C13.8834 4.13766 13.955 4.19245 14.016 4.25632L7.54047 7.995C7.49789 8.01958 7.45864 8.04771 7.42286 8.07879C7.38708 8.04771 7.34782 8.01958 7.30524 7.995L0.932373 4.31562Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesBox);
export default __webpack_public_path__ + "static/media/salesBox.f6b6e9c45cf6e2878afe4b7e02a500e4.svg";
export { ForwardRef as ReactComponent };